<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'top', params: {} }">
            <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui[4][1]"/></b>
        </h3>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">

          <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
            <b><trans-text :i18nKey="apiErrorI18nKey"/></b>
          </div>

          <!-- 入力フォーム -->
          <page-form @tryForm="tryForm"></page-form>

          <!-- 画面遷移UI -->
          <div class="row text-center">
            <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
              <div class="my-4">
                <router-link tag="button" class="btn w-100 btn-lg btn-default" :to="{ name: 'top', params:{} }">
                  <trans-text i18nKey="ui[4][6]"/>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from 'page/partials/DemoLogin/PageForm.vue'
  import Auth from 'processor/Auth'

  export default {
    name:"demoLogin",
    components: {
      PageForm,
    },
    data () {
      return {
        apiErrorI18nKey:null
      }
    },
    mounted(){
      if(store.get('token')){
        store.set('token',null)
      }
    },
    methods:{
      tryForm(input) {
        Auth.login(input)
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKey = res.apiErrorI18nKey
              return
            }
            this.$router.push({ name: 'mypage', params: {}})
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// DemoLogin.vue?248302a6